<ng-container>
  <div class="container my-3">
    <h2>{{ "shared.auth.logoutComplete.title" | transloco }}</h2>
    <ng-container *transloco="let t">
      <p class="mt-3"
        [innerHTML]="'shared.auth.logoutComplete.message' | transloco: { link: '<a href=\'/staff\' class=\'link cursor-pointer\'>einloggen</a>' }">
      </p>
    </ng-container>
  </div>
</ng-container>